import { PageHeader } from '@/shared/components/PageHeader';
import { CalendarOff } from 'lucide-react';
import LeaveTypesStep from '../components/LeaveTypesStep';

export default function LeaveTypesPage() {
  return (
    <div className="h-full flex flex-col bg-background overflow-hidden">
      <PageHeader
        title="Leave Types"
        subtitle="Manage leave types for the Leave Calendar"
        icon={<CalendarOff className="w-7 h-7" style={{ color: '#E84A2B' }} />}
        breadcrumbs={[
          { label: 'Settings', href: '/settings' },
          { label: 'Leave Types', current: true },
        ]}
      />
      <div className="flex-1 overflow-y-auto px-6 pb-6 pt-2">
        <LeaveTypesStep />
      </div>
    </div>
  );
}
